import { render, staticRenderFns } from "./AddImagesButton.vue?vue&type=template&id=67de4406&scoped=true&"
import script from "./AddImagesButton.vue?vue&type=script&lang=ts&"
export * from "./AddImagesButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddImagesButton.vue?vue&type=style&index=0&id=67de4406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de4406",
  null
  
)

export default component.exports